import styled, { css } from 'styled-components'
import { zIndex } from '../../Styles/Metrics'

const ErrorStyle = css`
  border: 1px solid ${({ theme }) => theme.error};
`

const ItemStyle = css`
  padding: .5rem .75rem;

  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  &:only-child {
    border-radius: 4px;
  }
`

const RightBorderRadius = css`
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
`

const InputWithLeftIconStyle = css`
  padding-left: 2.5rem;
  ${({ hasRightAddOn }) => !hasRightAddOn && RightBorderRadius}
`

const InputWithRightIconStyle = css`
  padding-right: 2.5rem;
  ${RightBorderRadius}
`

const DisabledStyle = css`
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    opacity: .5;
    height: 100%;
    z-index: ${zIndex.tooltip};
    background-color: ${({ theme }) => theme.border};
  }
`

export const Wrapper = styled.div`
  display: flex;
  position: relative;
  ${({ disabled }) => disabled && DisabledStyle}
`

const RightBorderStyle = css`
  &:not(:last-child) {
    border-right: 1px solid transparent;
  }
`

export const InputField = styled.input`
  flex: 1;
  color: inherit;
  cursor: default;
  line-height: 1.6;
  font-size: 1.5rem;
  transition: all .3s;
  font-family: inherit;
  background-color: rgba(255,255,255, .5);

  &:not(:first-child) {
    border-left: 1px solid transparent;
  }

  ${({ hasLeftIcon, hasRightIcon, hasRightAddOn }) => !(hasLeftIcon || hasRightIcon) && hasRightAddOn && RightBorderStyle}
  ${({ hasLeftIcon, hasRightAddOn }) => hasLeftIcon && hasRightAddOn && RightBorderStyle}

  border: 1px solid ${({ theme }) => theme.border};
  ${ItemStyle}


  &:focus {
    outline: none;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid ${({ theme }) => theme.primary};
  }

  &::-webkit-input-placeholder {
    color: ${({ theme }) => theme.textLight};
  }

  ${({ hasError }) => hasError && ErrorStyle}
  ${({ hasLeftIcon }) => hasLeftIcon && InputWithLeftIconStyle}
  ${({ hasRightIcon }) => hasRightIcon && InputWithRightIconStyle}
`

export const AddOnWrapper = styled.span`
  font: inherit;
  font-weight: normal;
  color: ${({ theme }) => theme.snow};
  background-color: ${({ theme }) => theme.primary};
  border: 1px solid ${({ theme }) => theme.primary};
  ${ItemStyle}
`

const IconWrapperStyle = css`
  top: 0;
  height: 100%;
  width: 2.5rem;
  display: flex;
  color: inherit;
  position: absolute;
  align-items: center;
  justify-content: center;
  z-index: ${zIndex.tooltip};
`

export const LeftIconWrapper = styled.span`
  ${IconWrapperStyle}
  left: 0;
`

export const RightIconWrapper = styled.span`
  ${IconWrapperStyle}
  right: 0;
`



// WEBPACK FOOTER //
// ./src/Components/Input/styles.js